/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetBankBaseRequest } from '../../models/get-bank-base-request';
import { GetBankResponse } from '../../models/get-bank-response';

export interface PostApiBankV1$Json$Params {

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
  
    /**
     * The request payload containing filter and pagination options.
     */
    body?: GetBankBaseRequest
}

export function postApiBankV1$Json(http: HttpClient, rootUrl: string, params?: PostApiBankV1$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<GetBankResponse>> {
  const rb = new RequestBuilder(rootUrl, postApiBankV1$Json.PATH, 'post');
  if (params) {
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetBankResponse>;
    })
  );
}

postApiBankV1$Json.PATH = '/private/v1/banks';
